import "./Newsletter.css"
import React from "react";
import NewsletterButton from "./NewsletterButton";
import { Link } from 'gatsby';
const Newsletter= () => (
    <>
      <section className="siteSection with-bg work-sec p-0">
        <img style={{ width: "8rem" }} src='rope.svg' alt="Web Development Company" />
        <div className="bgGradient blue full"></div>
        <h4 className="headerTagText">Website <br className="d-sm-none" /> Hacks
          <br className="d-sm-none" /> </h4>

        <section className="mt--100">
          <div className="container">
            <div className="row ">
              <div className="col-md-6">
                <h3 data-sal="slide-up" className="sec-title text-primary">Get Exclusive Tips to grow your Business from Website.<br/> That We Only Share With Email Subscribers</h3>
                <NewsletterButton/>
                <img style={{ width: "3rem", margin: "0rem 0rem 3rem 1rem" }} src='arrow.svg' alt="Call To Action" />
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
  export default Newsletter;



